import { render, staticRenderFns } from "./c-rules.vue?vue&type=template&id=6038990c&scoped=true&"
import script from "./c-rules.vue?vue&type=script&lang=js&"
export * from "./c-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6038990c",
  null
  
)

export default component.exports